<div class="workbasket" [ngClass]="[isExternalApp ? 'external' : '']"
    [attr.data-automation-id]="automationId + '-container'">
    <div class="topBar">
        <div>
            <i class="fa fa-shopping-basket" (click)="collapseCallback()" [ngClass]="{'disabled': isExternalApp}"
                [attr.data-automation-id]="automationId + '-collapse-button'" title="Hide Work Basket"></i>
            <span>Work Basket</span>
        </div>
        <div class="rightButtons">
            <i class="fa fa-window-restore" (click)="spawnWindow()" *ngIf="!isExternalApp"
                [attr.data-automation-id]="automationId + '-restore-button'" title="Open Work Basket in new window"></i>
            <i class="fa fa-question" (click)="openHelp()"
                [attr.data-automation-id]="automationId + '-help-button'"></i>
        </div>
    </div>
    <div class="filterArea">
        <div class="buttonBar">
            <button type="button" class="secondary-button showHideBtn" (click)="showHideFilters()"
                [attr.data-automation-id]="automationId + '-show-hide-filter-button'"
                [ngClass]="filtersOn ? 'filtersOn' : ''">
                <i class="fa fa-filter "
                    [ngClass]="['fa', 'fa-filter', filtersOn ? 'color-yellow-07' : 'color-grey-07']"
                    [attr.data-automation-id]="automationId + '-button-icon'"></i>{{showHideBtnLabel}}</button>
            <res-collapsible-toggle-box-group [toggleItems]="toggleFilters" [displayAlwaysOnRight]="false"
                (onToggleValueChanged)="onFilterToggleChanged($event)" [data-automation-id]="automationId">
            </res-collapsible-toggle-box-group>
        </div>
        <div class="taskFiltersBox" [hidden]="showFilters()">
            <res-task-filter (onApplyFilters)="onApplyFilters($event)" [automationId]="automationId"></res-task-filter>
        </div>
    </div>
    <res-generic-grid [gridName]="gridName" [automationId]="automationId" [columnDefs]="columnDefs"
        [rowSelection]="rowSelection" [cellClickedCallback]="cellClickedCallback"
        [cellDoubleClickedCallback]="cellDoubleClickedCallback" [contextMenuOptions]="contextMenuOptions"
        [requestInfo]="requestInfo" [onSelectionChanged]="onSelectionChanged" [gridContext]="gridContext"
        [responseArrayCallback]="responseArrayCallback" [pagerTemplate]="pagerTemplate" [pagerName]="pagerName"
        [updateStatusType]="updateStatusType" [onColumnVisibilityChanged]="onColumnVisibilityChanged.bind(this)">
    </res-generic-grid>
    <ng-template #pagerTemplate>
        <res-custom-checkbox content="Auto-update" [titleText]="'Auto-Update Work Basket'" [isWBDisabled]="updateStatusType === null"
            [automationId]="automationId + '-autoupdate'" [(ngModel)]="autoUpdate" (ngModelChange)="autoUpdateChanged()"
            [marginLeft]="10"></res-custom-checkbox>
    </ng-template>
    <a *ngIf="hasDocumentReportPermissions" download #downloadLink hidden target="_blank"></a>
</div>